import { TemplateRef } from '@angular/core';
import { FilterMetadata } from 'primeng/api';
import { RowsPerPage } from '../../shared/table-helpers/table-helper';
import { TableAction } from './table-action';
import { TableColumn } from './table-column';
import { TableEditMode } from './table-edit-mode';
import { TableRowEditMode } from './table-row-edit-mode';
import { TableSelectionMode } from './table-selection-mode';
import { TableSortOrder } from './table-sort-order';
export class TableConfig {

  public id: string;
  public title: string = '';
  public itemTypeName: string = '';
  public dataKey: string = '';

  public enableAdd: boolean = true;
  public enableEdit: boolean = true;
  public enableDelete: boolean = true;
  public enableScrolling: boolean = false;
  public canAdd: boolean = false;

  public enableFiltering: boolean = true;
  public enablePagination: boolean = true;
  public enableSorting: boolean = true;
  public enableColumnResize: boolean = true;

  public useSortTransformation: boolean = false;
  public enableHeader: boolean = true;
  public showHeader: boolean = true;
  public showFilters: boolean = false;
  public showRowIndexColumn: boolean = false;

  public lazyLoading: boolean = false;
  public lazyLoadOnInit: boolean = true;
  public rowsPerPage: number = RowsPerPage.Medium;
  public rowsPerPageOptions: number[];
  public totalRecords: number = 0;
  public enableSelectionColumn: boolean = false;
  public selectionMode: TableSelectionMode = null;
  public showSelectionBanner: boolean = true;
  public selectAllOnInit: boolean = false;
  public selectionPageOnly: boolean = true;

  public preventRowUnselect: boolean = false;
  public editMode: TableEditMode = TableEditMode.Row;
  public editEnabledPipe: any;
  public hideEditPipe: any;
  public hideDeletePipe: any;
  public rowEditMode: TableRowEditMode = TableRowEditMode.Dialog;
  public loading: boolean = false;
  public first: number = 0;
  public allowAddEmptyMessage: boolean = false;
  public filters: FilterMetadata[] = [];
  public startingSortField: string = null;
  public startingSortOrder: TableSortOrder = TableSortOrder.Ascending;
  public reorderableRow: boolean = false;
  public rowHighlightFunction: (rowData: any) => string;
  public showRowHighlightInfoColumn: boolean = true;
  public tooltipDelay: number = 500;
  public columns: TableColumn[] = [];
  public fixedColumns: TableColumn[] = [];
  public actions: TableAction[] = [];
  public showFixedColumns: boolean = false;
  public fixedColumnWidth: string = '40px';

  public disableRowByProp: boolean = false;
  public disableRowByPropValue: string = null;
  public groupRowTemplateRef: TemplateRef<any>;

  public deleteActionTitle: string = null;
  public emptyMessage: string = null;
}
